module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bottom-tool"
    }
  }, _vm._l((_vm.tools), function(tool) {
    return _c('router-link', {
      staticClass: "tool-item",
      attrs: {
        "to": tool.link
      }
    }, [_c('div', {
      staticClass: "iconfont",
      class: tool.className
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(tool.text))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3a506559!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/bottomTool.vue
// module id = 45
// module chunks = 1